/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactionDetails200ResponseTransactionRecordListInner } from './get-card-transaction-details200-response-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetCardTransactionDetails200Response
 */
export interface GetCardTransactionDetails200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200Response
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200Response
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200Response
     */
    'transactionType': GetCardTransactionDetails200ResponseTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200Response
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetCardTransactionDetails200ResponseTransactionRecordListInner>}
     * @memberof GetCardTransactionDetails200Response
     */
    'transactionRecordList': Array<GetCardTransactionDetails200ResponseTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionDetails200Response
     */
    'isCleared': boolean;
}

export const GetCardTransactionDetails200ResponseTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetCardTransactionDetails200ResponseTransactionTypeEnum = typeof GetCardTransactionDetails200ResponseTransactionTypeEnum[keyof typeof GetCardTransactionDetails200ResponseTransactionTypeEnum];


